<app-spinner [loading]="loading" [size]="'full'"></app-spinner> <router-outlet></router-outlet>
<app-inactivity-counter></app-inactivity-counter>
